module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', [(_vm.isLoading) ? _c('CustomLoader', {
    attrs: {
      "width": 70
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('b-card', {
    staticClass: "mainCardBG"
  }, [_c('b-card-text', [_c('b-navbar', {
    staticClass: "formCard",
    staticStyle: {
      "border-radius": "5px !important",
      "padding-left": "0px",
      "height": "auto !important"
    },
    attrs: {
      "toggleable": "lg",
      "type": "dark",
      "variant": "primary"
    }
  }, [_c('b-navbar-nav', [_c('b-button', {
    attrs: {
      "size": "sm",
      "variant": "light"
    },
    on: {
      "click": _vm.previousSalesView
    }
  }, [_c('md-icon', {
    attrs: {
      "icon": "gear-fill",
      "aria-hidden": "true"
    }
  }, [_vm._v("skip_previous")]), _vm._v("Back\n          ")], 1)], 1), _vm._v(" "), _c('b-navbar-brand', {
    attrs: {
      "center": ""
    }
  }, [_vm._v("Remark Master")]), _vm._v(" "), _c('b-navbar-nav', {
    staticClass: "ml-auto"
  }, [(
    _vm.$sessionsStorage.get('designation') == 'Admin' &&
    _vm.$sessionsStorage.get('nameUser') == 'Bhavneesh'
  ) ? _c('b-nav-form', [_c('b-button', {
    attrs: {
      "variant": "outline-primary",
      "size": "sm"
    },
    on: {
      "click": function($event) {
        _vm.addEditCardFunc()
      }
    }
  }, [_vm._v("Add")]), _vm._v(" "), _c('b-button', {
    staticClass: "ml-2",
    attrs: {
      "variant": "outline-success",
      "size": "sm"
    },
    on: {
      "click": _vm.showBulkUploadModal
    }
  }, [_vm._v("Bulk Upload")])], 1) : _vm._e()], 1)], 1), _vm._v(" "), _c('b-card', {
    staticClass: "formCard"
  }, [_c('b-card-text', [(_vm.addEditCard) ? _c('b-card', {
    staticClass: "gutr"
  }, [_c('b-row', {
    staticClass: "align-items-end"
  }, [_c('b-col', {
    attrs: {
      "md": "12"
    }
  }, [_c('h5', [_vm._v(_vm._s(_vm.RemarkMaster.documentName) + " Remark Details")])]), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', {
    attrs: {
      "for": "ModuleType"
    }
  }, [_vm._v("Module Type")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "isDisabled": true,
      "list": _vm.ModuleTypeList,
      "option-value": "ModuleTypeVal",
      "option-text": "ModuleTypeTxt",
      "placeholder": "Please Select ModuleType"
    },
    model: {
      value: (_vm.RemarkMaster.ModuleType),
      callback: function($$v) {
        _vm.$set(_vm.RemarkMaster, "ModuleType", $$v)
      },
      expression: "RemarkMaster.ModuleType"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', {
    attrs: {
      "for": "documentName"
    }
  }, [_vm._v("Name\n                  "), _c('span', {
    staticClass: "error"
  }, [_vm._v("*")])]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "documentName",
      "name": "documentName",
      "placeholder": "Remark Name"
    },
    model: {
      value: (_vm.RemarkMaster.documentName),
      callback: function($$v) {
        _vm.$set(_vm.RemarkMaster, "documentName", $$v)
      },
      expression: "RemarkMaster.documentName"
    }
  }), _vm._v(" "), (!_vm.RemarkMaster.documentName) ? _c('span', {
    staticClass: "error"
  }, [_vm._v("\n                  " + _vm._s(_vm.errorList.documentName) + "\n                ")]) : _vm._e()], 1), _vm._v(" "), _c('b-col', {
    staticStyle: {
      "display": "block"
    },
    attrs: {
      "md": "6",
      "id": "descriptionDiv"
    }
  }, [_c('label', [_vm._v(" Description ")]), _vm._v(" "), _c('b-form-textarea', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "description",
      "name": "description"
    },
    model: {
      value: (_vm.RemarkMaster.description),
      callback: function($$v) {
        _vm.$set(_vm.RemarkMaster, "description", $$v)
      },
      expression: "RemarkMaster.description"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_vm._v("Status :")]), _vm._v(" "), _c('md-switch', {
    staticClass: "md-primary",
    attrs: {
      "id": 'approval' + _vm.RemarkMaster.isDocumentActive,
      "name": "approval",
      "value": _vm.RemarkMaster.isDocumentActive == 1 ? true : false
    },
    on: {
      "change": function($event) {
        _vm.activateRemarkMaster()
      }
    }
  }, [_c('h6', [_c('b-badge', {
    attrs: {
      "variant": _vm.RemarkMaster.isDocumentActive == 1 ? 'success' : 'danger'
    }
  }, [_vm._v(_vm._s(_vm.RemarkMaster.isDocumentActive == 1 ?
    "Active" :
    "In-Active"))])], 1)])], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "12"
    }
  }, [_c('center', [_c('b-button', {
    staticClass: "mt-2",
    staticStyle: {
      "margin-bottom": "0.3rem"
    },
    attrs: {
      "variant": "success",
      "id": "addButtonLoader"
    },
    on: {
      "click": _vm.addRemarkMaster
    }
  }, [_vm._v("\n                    " + _vm._s(_vm.RemarkMaster.remarkId ? "Update" : "Save") + "\n                  ")])], 1), _vm._v(" "), _c('md-spinner', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "md-indeterminate": "",
      "id": "loader"
    }
  })], 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "mt-3"
  }, [_c('b-row', [_c('b-col', {
    staticClass: "my-1",
    attrs: {
      "md": "10"
    }
  }, [_c('b-form-group', [_c('b-input-group', [_c('b-form-input', {
    ref: "search",
    attrs: {
      "formatter": _vm.capitalizeAll,
      "placeholder": "Type to Search Remark"
    },
    on: {
      "input": _vm.debounceSearch
    },
    model: {
      value: (_vm.filter),
      callback: function($$v) {
        _vm.filter = $$v
      },
      expression: "filter"
    }
  }), _vm._v(" "), _c('b-input-group-append', [_c('b-button', {
    attrs: {
      "disabled": !_vm.filter
    },
    on: {
      "click": _vm.filterClear
    }
  }, [_vm._v("Clear")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "2"
    }
  }, [_c('h5', [(_vm.isLoading == false) ? _c('small', [_vm._v(_vm._s(_vm.totalRows) + " Entries")]) : _vm._e()])])], 1), _vm._v(" "), _c('div', {
    staticClass: "table-responsive tableMain"
  }, [_c('b-table', {
    staticClass: "position-relative",
    attrs: {
      "show-empty": "",
      "stacked": "md",
      "items": _vm.All_Remark_List_data,
      "fields": _vm.fields,
      "filter": _vm.filter,
      "sort-by": _vm.sortBy,
      "sort-desc": _vm.sortDesc,
      "sort-direction": _vm.sortDirection,
      "responsive": "",
      "primary-key": "remarkId"
    },
    on: {
      "update:sortBy": function($event) {
        _vm.sortBy = $event
      },
      "update:sortDesc": function($event) {
        _vm.sortDesc = $event
      },
      "filtered": _vm.onFiltered
    },
    scopedSlots: _vm._u([{
      key: "remarkId",
      fn: function(row0) {
        return [_c('span', [_vm._v(_vm._s(row0.index + 1 + (_vm.currentPage - 1) * _vm.perPage))])]
      }
    }, {
      key: "ModuleType",
      fn: function(row55) {
        return [_c('span', [_vm._v(_vm._s(row55.item.ModuleType != "" ? row55.item.ModuleType : "--"))])]
      }
    }, {
      key: "documentName",
      fn: function(row11) {
        return [_c('span', [_vm._v(_vm._s(row11.item.documentName != "" ? row11.item.documentName : "--"))])]
      }
    }, {
      key: "isDocumentActive",
      fn: function(row22) {
        return [(_vm.adminToggle == 'Admin') ? _c('div', {
          attrs: {
            "id": 'row' + row22.item.remarkId
          }
        }, [_c('md-switch', {
          staticClass: "md-primary",
          attrs: {
            "id": 'approval' + row22.item.remarkId,
            "name": "approval",
            "value": row22.item.isDocumentActive == 1 ? true : false
          },
          on: {
            "change": function($event) {
              _vm.activateRemarkUser(row22.item)
            }
          }
        }, [_c('h6', [_c('br'), _vm._v(" "), _c('b-badge', {
          staticStyle: {
            "margin-left": "-45px"
          }
        }, [_vm._v(_vm._s(row22.item.isDocumentActive == 1 ? "Active" : "In-Active"))])], 1)])], 1) : _c('div', {
          attrs: {
            "id": 'row' + row22.item.remarkId
          }
        }, [_c('h6', [_c('b-badge', [_vm._v(_vm._s(row22.item.isDocumentActive == 1 ? "Active" : "In-Active"))])], 1)])]
      }
    }, {
      key: "action",
      fn: function(row2) {
        return [_c('b-button', {
          attrs: {
            "variant": "outline-primary",
            "id": "addButtonLoader",
            "size": "sm"
          },
          on: {
            "click": function($event) {
              _vm.editRemarkMaster(row2.item)
            }
          }
        }, [_vm._v("Update")])]
      }
    }])
  })], 1), _vm._v(" "), _c('b-row', [_c('b-col', {
    staticClass: "my-1",
    attrs: {
      "md": "12"
    }
  }, [_c('b-pagination', {
    staticClass: "my-0 pull-right",
    attrs: {
      "limit": "5",
      "total-rows": _vm.totalRows,
      "per-page": _vm.perPage
    },
    model: {
      value: (_vm.currentPage),
      callback: function($$v) {
        _vm.currentPage = $$v
      },
      expression: "currentPage"
    }
  })], 1)], 1)], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('md-dialog-alert', {
    ref: "addPop",
    attrs: {
      "md-content": _vm.alert.content,
      "md-ok-text": _vm.alert.ok
    }
  }), _vm._v(" "), _c('b-modal', {
    attrs: {
      "id": "bulkUploadModal",
      "title": "Bulk Upload Remarks",
      "size": "lg",
      "hide-footer": ""
    },
    model: {
      value: (_vm.showBulkModal),
      callback: function($$v) {
        _vm.showBulkModal = $$v
      },
      expression: "showBulkModal"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Select Excel File",
      "label-for": "file-input"
    }
  }, [_c('b-form-file', {
    attrs: {
      "id": "file-input",
      "state": Boolean(_vm.uploadFile),
      "placeholder": "Choose a file or drop it here...",
      "drop-placeholder": "Drop file here...",
      "accept": ".xlsx, .xls"
    },
    on: {
      "change": _vm.handleFileUpload
    },
    model: {
      value: (_vm.uploadFile),
      callback: function($$v) {
        _vm.uploadFile = $$v
      },
      expression: "uploadFile"
    }
  })], 1), _vm._v(" "), (_vm.uploadPreview.length > 0) ? _c('div', {
    staticClass: "mt-3"
  }, [_c('h5', [_vm._v("Preview (" + _vm._s(_vm.uploadPreview.length) + " records)")]), _vm._v(" "), _c('b-table', {
    staticStyle: {
      "max-height": "300px",
      "overflow-y": "auto"
    },
    attrs: {
      "striped": "",
      "hover": "",
      "items": _vm.uploadPreview,
      "fields": ['documentName', 'ModuleType', 'description'],
      "small": "",
      "responsive": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "text-right mt-2"
  }, [_c('b-button', {
    attrs: {
      "variant": "primary",
      "disabled": _vm.uploadLoading
    },
    on: {
      "click": _vm.submitBulkUpload
    }
  }, [(_vm.uploadLoading) ? _c('b-spinner', {
    attrs: {
      "small": ""
    }
  }) : _vm._e(), _vm._v("\n            " + _vm._s(_vm.uploadLoading ? 'Uploading...' : 'Upload') + "\n          ")], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.uploadError) ? _c('div', {
    staticClass: "text-danger mt-2"
  }, [_vm._v("\n      " + _vm._s(_vm.uploadError) + "\n    ")]) : _vm._e(), _vm._v(" "), (_vm.uploadSuccess) ? _c('div', {
    staticClass: "text-success mt-2"
  }, [_vm._v("\n      " + _vm._s(_vm.uploadSuccess) + "\n    ")]) : _vm._e()], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-51809fcc","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/component/masters/remarkMaster.vue
// module id = 2623
// module chunks = 0